/** @format */

/* eslint @typescript-eslint/dot-notation: "warn" */
import axios from 'axios';

import { changeCaseInterceptor } from '@toucan/client/global/axios';

export type FormValues = Record<string, string | boolean>;

function responseRejected(error: any) {
    // Get the first validation message for each form field
    if (error?.response?.data?.data?.errors) {
        error['validationErrors'] = {};
        Object.keys(error.response.data.data.errors).map((fieldName) => {
            error.validationErrors[fieldName] =
                error.response.data.data.errors[fieldName][0];
        });
    }
    return Promise.reject(error);
}

export const validationMessagesInterceptor = {
    responseRejected,
};

export function escapeValues(values: FormValues): FormValues {
    const escaped: FormValues = {};
    Object.keys(values).forEach((key) => {
        if (Object.keys(values).includes(key)) {
            escaped[key] = encodeURIComponent(values[key]);
        }
    });
    return escaped;
}

const client = axios.create();

// Rename object keys to and from the API so we can model our data in camelCase
// But send and receive in snake_case for the pythons.
client.interceptors.request.use(
    changeCaseInterceptor.requestFulfilled,
    undefined
);
client.interceptors.response.use(
    changeCaseInterceptor.responseFulfilled,
    changeCaseInterceptor.responseRejected
);

// Move validation messages to the top level of the error
client.interceptors.response.use(
    undefined,
    validationMessagesInterceptor.responseRejected
);

export { client };
